import { render, staticRenderFns } from "./LibraryCard.vue?vue&type=template&id=82d5e2c0&scoped=true"
import script from "./LibraryCard.vue?vue&type=script&lang=js"
export * from "./LibraryCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryCard.vue?vue&type=style&index=0&id=82d5e2c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d5e2c0",
  null
  
)

export default component.exports